"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxIcon = void 0;
const react_1 = __importStar(require("react"));
const CheckboxIcon_styles_1 = require("./CheckboxIcon.styles");
const CheckboxIconMode_1 = require("./types/CheckboxIconMode");
exports.CheckboxIcon = react_1.default.memo(function CheckboxIcon(_a) {
    var { mode = CheckboxIconMode_1.CheckboxIconMode.noSelected, ['data-selector-id']: initialDataSelectorId, style } = _a, rest = __rest(_a, ["mode", 'data-selector-id', "style"]);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'checkbox-icon', [initialDataSelectorId]);
    return (react_1.default.createElement(CheckboxIcon_styles_1.StyledCheckboxIcon, Object.assign({}, rest, { role: "presentation", "data-selector-id": dataSelectorId, viewBox: "0 0 20 20", width: "20px", height: "20px", style: style }),
        mode === CheckboxIconMode_1.CheckboxIconMode.selected && (react_1.default.createElement(CheckboxIcon_styles_1.StyledCheckboxIconCenterFigure, { fill: "currentColor", points: "8 15.5 17 6.5 15 4.5 8 11.5 5 8.5 3 10.5 8 15.5" })),
        mode === CheckboxIconMode_1.CheckboxIconMode.indeterminate && (react_1.default.createElement(CheckboxIcon_styles_1.StyledCheckboxIconCenterFigure, { fill: "currentColor", points: "5,5 15,5 15,15 5,15" })),
        react_1.default.createElement(CheckboxIcon_styles_1.StyledCheckboxIconBorder, { fill: "currentColor", d: "M0,0V20H20V0ZM19,19H1V1H19Z" })));
});
//# sourceMappingURL=CheckboxIcon.js.map